import { createAction } from '@reduxjs/toolkit';

export const ACCEPT_USER_INVITE = 'Signup/UserInvites/ACCEPT_USER_INVITE';

export const acceptUserInvite = createAction(ACCEPT_USER_INVITE);
